import im1 from '../Banner images/AboutUs.webp';
import NB1 from '../Blogs copy/Blogs Images/newsbox image-1.svg';
import NB2 from '../Blogs copy/Blogs Images/newsbox image-2.svg';
import NB3 from '../Blogs copy/Blogs Images/newsbox image-3.svg';

import D12thsep from '../Blogs copy/Blogs Images/12thSep.jpeg';
import D14thsep from '../Blogs copy/Blogs Images/14thSep.jpeg';
import D28thsep from '../Blogs copy/Blogs Images/28thSep.jpeg';
import D12thOct from '../Blogs copy/Blogs Images/12thOct.png';
export interface BlogContent {
    type: 'h1' |'h2'|'h3'|'h4' |'paragraph';
    content: string;
  }
  
  export interface Blog {
    id: string;
    date:string;
    title: string;
    imamge:string;
    excerpt: string;
    content: BlogContent[];
  }
  

  
  export const blogs: Blog[] = [
    {
      id: '1',
      date:'14-09-2024',
      title: 'we concluded our 80th RMB meeting, and it was a truly fruitful session!',
      imamge:D14thsep,
      excerpt: 'A special shoutout to Kshitij @phf.kshitij, our RMBian of the day, for making this meeting even more impactful. Here’s to continued growth',
      content: [
        { type: 'h1', content: '' },
        { type: 'paragraph', content: 'The RMB Jaipur Chapter proudly presented the Leadership Awards for January to June' },
      ],
    },
    {
      id: '2',
      date:'28-09-2024',
      title: 'we concluded our 81th RMB meeting, and it was a truly fruitful session!',
      imamge:D28thsep,
      excerpt: 'A special shoutout to Kshitij @phf.kshitij, our RMBian of the day, for making this meeting even more impactful. Here’s to continued growth',
      content: [
        { type: 'h1', content: '' },
        { type: 'paragraph', content: 'The RMB Jaipur Chapter proudly presented the Leadership Awards for January to June' },
      ],
    },
    {
      id: '3',
      date:'12-10-2024',
      title: 'we concluded our 82 th RMB meeting, and it was a truly fruitful session!',
      imamge:D12thOct,
      excerpt: 'Congratulation to @joshi.rishi , our RMBian of the Meeting, for making this meeting even more impactful. Here’s to continued growth',
      content: [
        { type: 'h1', content: '' },
        { type: 'paragraph', content: 'Today, we concluded our 82 th RMB meeting, and it was a truly fruitful session! It was filled with insightful presentations, engaging discussions, and valuable networking. Congratulation to @joshi.rishi , our RMBian of the Meeting, for making this meeting even more impactful. Here’s to continued growth and meaningful connections through Rotary Means Business Join us for unparalleled networking opportunities, grow your business, and expand globally! 🌍Connect. Collaborate. Conquer. 🚀Please like, share, and comment. If you want to grow your business, contact us immediately' },
      ],
    },
    
    
  
  ];
  



